function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Constants } from './../utils/constants';
import { getWindow } from './../services/window';
import { getAppConfig } from './../services/init/appConfig';
import { getLocalStorageItem, saveLocalStorageItem } from './../utils/browserStorageUtils';
import { isEmptyNullorUndefinedString } from './../utils/stringUtils';
import { logger } from '@src/logger';
(function(NpsModule) {
    let showModal;
    let npsHelper = null;
    let idleCounter = 0;
    let blocked = false;
    let idleTimer = null;
    let isNotSameCorrelationId = false;
    let sessionStartTime = 0;
    function setTimer(callback, interval) {
        // check every 1 second
        idleTimer = window.setInterval(callback, interval || 1000);
    }
    NpsModule.setTimer = setTimer;
    function reset() {
        blocked = false;
        idleTimer = null;
    }
    NpsModule.reset = reset;
    function dLog(debugMsg) {
        const data = {
            npsFrom: debugMsg,
            npsStore: npsHelper.getStore()
        };
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.NPS,
            actionModifier: Constants.Telemetry.ActionModifier.Debug,
            details: JSON.stringify(data)
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    function checkForNPS(viewedAppsCount, acquiredAppsCount, interval, debugMsg) {
        if (npsHelper) {
            const waitTime = 30 * 1000; // If all conditions are met, we wait for 30 seconds since the start-up to show the NPS popup.
            const currentTime = Date.now();
            if (sessionStartTime && currentTime - sessionStartTime > waitTime) {
                const oneHourInMS = 1000 * 60 * 60;
                const savedSessionEndTime = npsHelper.getItem('sessionEndTime');
                const viewedApps = viewedAppsCount || npsHelper.getItem('viewedApps');
                const acquiredApps = acquiredAppsCount || npsHelper.getItem('acquiredApps');
                const isAppsCriteriaValid = viewedApps && viewedApps >= npsHelper.viewedAppsTriggerNumber || acquiredApps && acquiredApps >= npsHelper.acquiredAppsTriggerNumber;
                const isTimeCriteriaValid = savedSessionEndTime && sessionStartTime - savedSessionEndTime > oneHourInMS;
                if (isTimeCriteriaValid && isAppsCriteriaValid && isNotSameCorrelationId && npsHelper.due() && idleTimer == null) {
                    // turn on the timer
                    setTimer(()=>{
                        if (!blocked) {
                            idleCounter++;
                            if (idleCounter >= 3) {
                                window.clearInterval(idleTimer);
                                idleTimer = null;
                                dLog(debugMsg);
                                ResetNPSCount();
                                showModal();
                            }
                        }
                    }, interval);
                }
            }
        }
    }
    NpsModule.checkForNPS = checkForNPS;
    function IncreaseAppDetail(interval) {
        if (npsHelper) {
            let viewedApps = npsHelper.getItem('viewedApps');
            if (!viewedApps) {
                viewedApps = 1;
            } else {
                viewedApps += 1;
            }
            npsHelper.setItem('viewedApps', viewedApps);
            checkForNPS(viewedApps, npsHelper.getItem('acquiredApps'), interval, 'detailsPage');
        }
    }
    NpsModule.IncreaseAppDetail = IncreaseAppDetail;
    function IncreaseAppAcquisition(interval) {
        if (npsHelper) {
            let acquiredApps = npsHelper.getItem('acquiredApps') || 0;
            acquiredApps++;
            npsHelper.setItem('acquiredApps', acquiredApps);
            checkForNPS(npsHelper.getItem('viewedApps'), acquiredApps, interval, 'detailsPage');
        }
    }
    NpsModule.IncreaseAppAcquisition = IncreaseAppAcquisition;
    function ResetNPSIdle() {
        if (npsHelper) {
            idleCounter = 0;
        }
    }
    NpsModule.ResetNPSIdle = ResetNPSIdle;
    function ResetNPSCount() {
        if (npsHelper) {
            npsHelper.setItem('viewedApps', 0);
            npsHelper.setItem('acquiredApps', 0);
            npsHelper.setItem('sessionEndTime', null);
        }
    }
    NpsModule.ResetNPSCount = ResetNPSCount;
    function SetShortInterval() {
        if (npsHelper) {
            npsHelper.setNext(npsHelper.shortInterval);
        }
    }
    NpsModule.SetShortInterval = SetShortInterval;
    function SetInterval(interval, offset) {
        if (npsHelper) {
            npsHelper.setNext(interval, offset);
        }
    }
    NpsModule.SetInterval = SetInterval;
    function Declined() {
        if (npsHelper) {
            if (npsHelper.getItem('secondTime')) {
                npsHelper.setItem('secondTime', false);
                npsHelper.setNext(npsHelper.longInterval);
            } else {
                npsHelper.setItem('secondTime', true);
                npsHelper.setNext(npsHelper.shortInterval);
            }
        }
    }
    NpsModule.Declined = Declined;
    function Submitted() {
        if (npsHelper) {
            // succeeded
            npsHelper.setItem('secondTime', false);
            npsHelper.setNext(npsHelper.longInterval);
        }
    }
    NpsModule.Submitted = Submitted;
    function BlockShowingNPS() {
        if (npsHelper) {
            blocked = true;
        }
    }
    NpsModule.BlockShowingNPS = BlockShowingNPS;
    function AllowShowingNPS() {
        if (npsHelper) {
            blocked = false;
            ResetNPSIdle();
        }
    }
    NpsModule.AllowShowingNPS = AllowShowingNPS;
    function SaveSessionEndTime() {
        if (npsHelper) {
            const savedSessionEndTime = npsHelper.getItem('sessionEndTime');
            // save if it is set to null or doesn't exist
            // opening the NPS model will set it to null (inside ResetNPS)
            if (!savedSessionEndTime) {
                npsHelper.setItem('sessionEndTime', Date.now());
            }
        }
    }
    NpsModule.SaveSessionEndTime = SaveSessionEndTime;
    function Initialize(showModalFunction, timerInterval) {
        // only init from client
        sessionStartTime = Date.now();
        showModal = showModalFunction;
        npsHelper = new Nps();
        const currentCorrelationId = getAppConfig('correlationId');
        const savedCorrelationId = npsHelper.getItem('correlationId');
        if (savedCorrelationId && currentCorrelationId !== savedCorrelationId) {
            isNotSameCorrelationId = true;
        } else {
            isNotSameCorrelationId = false;
            npsHelper.setItem('correlationId', currentCorrelationId);
        }
        let viewedApps = npsHelper.getItem('viewedApps');
        if (!viewedApps) {
            viewedApps = 0;
        }
        let acquiredApps = npsHelper.getItem('acquiredApps');
        if (!acquiredApps) {
            acquiredApps = 0;
        }
        checkForNPS(viewedApps, acquiredApps, timerInterval, 'landingPage');
    }
    NpsModule.Initialize = Initialize;
    class Nps {
        reset(next) {
            let initNext = next || Date.now();
            initNext += this.timeTriggerInterval; // This is added to find the 'time' at which we need to show the nps for the first time
            const date = new Date(initNext);
            const store = {
                next: initNext,
                nextText: date.toString(),
                secondTime: false,
                viewedApps: 0,
                acquiredApps: 0,
                sessionEndTime: null
            };
            this.setStore(store);
            return store;
        }
        getStore() {
            try {
                const storeString = getLocalStorageItem(this.storeTitle);
                if (!isEmptyNullorUndefinedString(storeString)) {
                    return JSON.parse(storeString);
                } else {
                    return this.reset();
                }
            } catch (e) {
                return this.reset();
            }
        }
        setStore(store) {
            const storeString = JSON.stringify(store);
            try {
                saveLocalStorageItem(this.storeTitle, storeString);
            } catch (e) {
            // In case of quota exceed exception we dont want to crash rather not let NPS show up.
            }
        }
        getItem(section) {
            const store = this.getStore();
            if (store && section in store) {
                return store[`${section}`];
            } else {
                return null;
            }
        }
        setItem(section, data) {
            const store = this.getStore();
            if (store) {
                store[`${section}`] = data;
            }
            this.setStore(store);
        }
        getNext() {
            const next = this.getItem(Constants.LocalStorage.npsNext);
            if (next) {
                return next;
            } else {
                return 0;
            }
        }
        setNext(next, offset = true) {
            if (offset) {
                next = Date.now() + next;
            }
            const nextText = new Date(next);
            this.setItem(Constants.LocalStorage.npsNext, next);
            this.setItem(Constants.LocalStorage.npsNextText, nextText.toString());
        }
        due(next) {
            const by = next || this.getNext();
            const now = Date.now();
            return now >= by;
        }
        constructor(){
            _define_property(this, "longInterval", void 0);
            _define_property(this, "shortInterval", void 0);
            _define_property(this, "timeTriggerInterval", void 0);
            _define_property(this, "viewedAppsTriggerNumber", void 0);
            _define_property(this, "acquiredAppsTriggerNumber", void 0);
            _define_property(this, "storeTitle", void 0);
            this.storeTitle = Constants.LocalStorage.nps;
            this.longInterval = 1000 * 3600 * 24 * 30 * 3; // delay after accepting
            this.shortInterval = 1000 * 3600 * 24 * 30 * 1; // delay after denying
            this.timeTriggerInterval = 1000 * 3600 * 1; // amount of delay the user needs to wait to see an nps dialog after the first visit
            this.viewedAppsTriggerNumber = 2; // amount of apps viewed has to be greater than this number in order to trigger nps
            this.acquiredAppsTriggerNumber = 1; // amount of apps that need to be acquired before triggering nps
        }
    }
})(NpsModule || (NpsModule = {}));
export var NpsModule;
